import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.edit-reconcile-session.presenters.EditReconcileSessionPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to update the reconciliation session.',
  },
})
